<template>
    <div class="tab-pane" :class="activeTab == 2 ? 'active': 'default'" id="profile" role="tabpanel" aria-labelledby="profile-tab">

        <!-- Modal -->
        <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Información de teléfono</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form @submit.prevent="handleSubmitStep2('form-2')" data-vv-scope="form-2">
                            <div class="form-row">
                                <div class="col-md-12">
                                    <label for="" class="form-label">Numero de teléfono *</label>
                                    <input v-model="phone.PhoneNumber" v-validate="{ required: true, regex: constants.PHONE_NUMBER }" :class="{ 'is-invalid': submitted && errors.has('form-2.phoneNumber') }" data-vv-scope="form-2" name="phoneNumber" type="text" class="form-control" id="idNumber" placeholder="88888888">
                                    <div v-if="submitted && errors.has('form-2.phoneNumber')" class="invalid-feedback">{{ errors.first('form-2.phoneNumber') }}</div>
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="col-md-12">
                                    <label for="" class="form-label">Extensión de teléfono *</label>
                                    <input v-model="phone.PhoneExtension" :class="{ 'is-invalid': submitted && errors.has('form-2.extensionNumber') }" data-vv-scope="form-2" name="extensionNumber" type="text" class="form-control" id="idNumber">
                                    <div v-if="submitted && errors.has('form-2.extensionNumber')" class="invalid-feedback">{{ errors.first('form-2.extensionNumber') }}</div>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="form-label" for="exampleFormControlSelect2">Tipo de teléfono</label>
                                <select v-validate="'required'" data-vv-scope="form-2" @change="setTypeName($event)" v-model="phone.PhoneType.IdPhoneType" :class="{ 'is-invalid': submitted && errors.has('form-2.phoneType') }" name="phoneType" class="form-control" id="exampleFormControlSelect2">
                                    <option value="1">Celular</option>
                                    <option value="2">Casa</option>
                                    <option value="3">Oficina</option>
                                    <option value="4">Fax</option>
                                </select>
                                <div v-if="submitted && errors.has('form-2.phoneType')" class="invalid-feedback">{{ errors.first('form-2.phoneType') }}</div>
                            </div>
                            <div>
                                <button class="btn btn-primary">Agregar</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-11 col-md-9 col-lg-5">
                <div class="form-container">
                    <form @submit.prevent="handleSubmitStep2('form-1')">
                        <h2>2. Datos personales</h2>
                        <div class="form-group" v-if="personalAccount">
                            <label class="form-label" for="exampleFormControlSelect1">Tipo de identificación</label>
                            <select v-model="Consignee.IdentificationType" @change="Consignee.IdentificationType == 'Pasaporte' ? Consignee.Responsabilidad = 0 : Consignee.Responsabilidad = ''" class="form-control" id="exampleFormControlSelect1">
                                <option value="Cedula ó Residencia">Física</option>
                                <option value="Pasaporte">Extranjero</option>
                                <option value="Otro">Otro</option>
                            </select>
                        </div>
                        <div class="form-row">
                            <div class="col-md-12">
                                <label for="" class="form-label">Numero de identificación *</label>
                                <input 
                                    v-model="Consignee.IdentificationNumber" 
                                    v-validate="Consignee.IdentificationType == 'Cedula ó Residencia' ? { required: true, regex: constants.ID_NUMBER_REGEX } :
                                    Consignee.IdentificationType == 'Pasaporte' ? { required: false } :
                                    Consignee.IdentificationType == 'Otro' ? { required: true, regex:  constants.ID_ENTERPRISE_REGEX } :
                                    enterpriseAccount ? { required: true, regex:  constants.ID_ENTERPRISE_REGEX } : null"
                                    :disabled="Consignee.IdentificationType == 'Pasaporte'"
                                    :class="{ 'is-invalid': submitted && errors.has('form-1.IdNumber') }" 
                                    name="IdNumber" 
                                    type="text" 
                                    class="form-control" 
                                    id="idNumber" 
                                    :placeholder="Consignee.IsCompany ? 'ej: 3101121231' :
                                     Consignee.IdentificationType == 'Cedula ó Residencia' ? 'ej: 101230456' :
                                     Consignee.IdentificationType == 'Otro' ? 'ej: 1012304565' : null"
                                     data-vv-scope="form-1">
                                
                                <div v-if="submitted && errors.has('form-1.IdNumber')" class="invalid-feedback">{{ errors.first('form-1.IdNumber') }}</div>
                            </div>
                        </div>
    
                        <div v-if="Consignee.IdentificationType == 'Pasaporte'" class="form-group">
                            <label class="form-label" for="exampleFormControlSelect2">Responsabilidad *</label>
                            <select v-model="Consignee.Responsabilidad" class="form-control" id="exampleFormControlSelect2">
                                <option value="0">Dimex</option>
                                <option value="1">Nite</option>
                            </select>
                        </div>
                        <div v-if="Consignee.IdentificationType == 'Pasaporte'" class="form-row">
                            <div class="col-md-12">
                                <label for="" class="form-label">Numero de identificación *</label>
                                <input 
                                @change="Consignee.IdentificationNumber = Consignee.IdResponsabilidad" 
                                v-model="Consignee.IdResponsabilidad" 
                                v-validate="Consignee.Responsabilidad == 0 ? { required: true, regex:  constants.DIMEX } :
                                Consignee.Responsabilidad == 1 ? { required: true, regex:  constants.NITE } : null" 
                                name="passportNumber" 
                                type="text" 
                                class="form-control" 
                                id="idNumber2"
                                data-vv-scope="form-1"
                                :class="{ 'is-invalid': submitted && errors.has('passportNumber') }"  
                                :placeholder="Consignee.Responsabilidad == 0 ? 'De 11 a 12 dígitos y no empezar con 0' : 'Número de 10 dígitos' ">
                                <div v-if="submitted && errors.has('passportNumber')" class="invalid-feedback">{{ errors.first('passportNumber') }}</div>
                            </div>
                        </div>
    
                        <div class="form-group">
                            <label class="form-label" for="exampleFormControlSelect2">Idioma</label>
                            <select class="form-control" id="exampleFormControlSelect2">
                                <option value="Español">Español</option>
                                <option value="English">Inglés</option>
                                <option value="Otro">Otro</option>
                            </select>
                        </div>
    
                        <div class="form-row-spacing">
                            <div class="form-row" v-for="(phone, index) in 2" :key="index">
                                <div class="col-md-12">
                                    <label for="" class="form-label">Número de teléfono {{index + 1}} <span v-if="index == 0">*</span></label>
                                    <div class="add-info flex-row">
                                        <div class="circle-number flex-row" @click="selectedPhoneIndex = index" data-toggle="modal" data-target="#exampleModal">
                                            <span>+</span>
                                        </div>
                                        <input @click="selectedPhoneIndex = index; populatePhoneInfo()" data-toggle="modal" data-target="#exampleModal" v-validate="index == 0 ? { required: true, regex: /^\d{8}$/ } : null" :class="{ 'is-invalid': submitted && errors.has('form-1.showNumber' + ( index + 1 )) }" data-vv-scope="form-1" v-model="phoneNumbers[index].phoneNumber" :name="'showNumber' + ( index + 1 )" type="text" class="form-control" id="phoneNumber2" placeholder="8888-8888">
                                        <div v-if="submitted && errors.has('form-1.showNumber' + ( index + 1 ))" class="invalid-feedback">{{ errors.first('form-1.showNumber' + ( index + 1 )) }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <button class="default-button default-button-form">Siguiente</button>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import * as regexConstants from '@/constants/regex'
export default {
    props: ['activeTab', 'Consignee', 'extraParams' , 'personalAccount', 'enterpriseAccount'],
    data () {
            return {
                submitted: false,
                selectedPhoneIndex: '',
                phoneNumbers: [
                    {phoneNumber: ''},
                    {phoneNumber: ''},
                ],
                phone: {
                    IdPhone: '',
                    PhoneNumber: '',
                    PhoneExtension: '',
                    PhoneType: {
                        IdPhoneType: '', // Oficina 3, Casa 2, Celular 1, Fax 4
                        PhoneTypeName: ''
                    }
                },
                constants: { ...regexConstants }
            }
    },
    methods: {
        handleSubmitStep2(scope) {
            this.submitted = true;
            this.$validator.validateAll(scope).then(valid => {
                if (valid) {
                    if(scope == 'form-1'){
                        if(this.Consignee.IdentificationType != 'Pasaporte'){
                            this.Consignee.IdResponsabilidad = null;
                            this.Consignee.Responsabilidad = 0;
                        }
                        this.$emit('updateConsignee', {consignee: this.Consignee, params: this.extraParams});
                    }
                    else if(scope == 'form-2'){
                        this.savePhoneData();
                        document.querySelector('.close').click();
                        this.$validator.reset();
                    }
                }
            });
        },
        setTypeName(e) {
            this.phone.PhoneType.PhoneTypeName = e.target.options[e.target.selectedIndex].text;
        },
        savePhoneData() {
            this.extraParams.phones[this.selectedPhoneIndex] = this.phone;
            this.extraParams.phones[this.selectedPhoneIndex].IdPhone = this.selectedPhoneIndex;
            this.phoneNumbers[this.selectedPhoneIndex].phoneNumber = this.extraParams.phones[this.selectedPhoneIndex].PhoneNumber;
            
            this.phone = {
                IdPhone: '',
                PhoneNumber: '',
                PhoneExtension: '',
                PhoneType: {
                    IdPhoneType: '', // Oficina 3, Casa 2, Celular 1, Fax 4
                    PhoneTypeName: ''
                }
            };
        },
        populatePhoneInfo() {
            if(this.extraParams.phones[this.selectedPhoneIndex] != undefined || this.extraParams.phones[this.selectedPhoneIndex] != null)
                this.phone = this.extraParams.phones[this.selectedPhoneIndex];
        }
    },
    mounted() {
        this.Consignee.IdentificationType = 'Cedula ó Residencia';
    }
}
</script>

